import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import type { InfraHeartbeat, InfrastructureEnvelope } from '@/lib/mqtt/schemas/infrastructure';

interface InfraStore {
  byId: Record<string, InfraHeartbeat>;
  selectedId: string | null;
  filterStatus: Record<'active' | 'degraded' | 'inactive', boolean>;
  filterType: Record<'F' | 'M', boolean>;
  apply: (env: InfrastructureEnvelope) => void;
  select: (id: string | null) => void;
  toggleStatus: (k: 'active' | 'degraded' | 'inactive') => void;
  toggleType: (k: 'F' | 'M') => void;
}

export const useInfraStore = create<InfraStore>()(
  devtools(
    subscribeWithSelector((set) => ({
      byId: {},
      selectedId: null,
      filterStatus: { active: true, degraded: true, inactive: true },
      filterType: { F: true, M: true },
      apply: (env) =>
        set((s) => ({
          byId: { ...s.byId, ...Object.fromEntries(env.sites.map((x) => [x.site_id, x])) },
        })),
      select: (id) => set({ selectedId: id }),
      toggleStatus: (k) => set((s) => ({ filterStatus: { ...s.filterStatus, [k]: !s.filterStatus[k] } })),
      toggleType: (k) => set((s) => ({ filterType: { ...s.filterType, [k]: !s.filterType[k] } })),
    })),
    { name: 'infra' },
  ),
);
